import { createFetchedDataRecord } from '../../../../utils/fetched-data/create-fetched-data-record';
import { updateObject } from '../../../../utils/object-utils';
import { salesDataDomainStore } from '../../store';
export const assignItemRelatedData = (relatedData, cacheDuration) => {
    updateObject(salesDataDomainStore.data.itemModifierGroupsById, createFetchedDataRecord(relatedData.itemModifierGroups, 'id', cacheDuration));
    updateObject(salesDataDomainStore.data.discountsById, createFetchedDataRecord(relatedData.discounts, 'id', cacheDuration));
};
